import React from 'react';

const BedroomCheckBox = ({ value, onClick, isBedroomActive }) => (
  <div className="search-filters__drop-item search-filters__drop-item--plots">
    <input
      type="checkbox"
      name="bedsSelected"
      className="search-filters__checkbox"
      checked={isBedroomActive}
      value={value}
      onChange={onClick}
    />
    <label htmlFor="bedsSelected" className="search-filters__item-label">
      {value} beds
    </label>
  </div>
);

export default BedroomCheckBox;
